import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../../contexts/userContext';
import request from '../../../services/Request';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import BackButton from '../../items/buttons/BackButton';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import {
  FormControlLabel,
  RadioGroup,
  Grid,
  Radio,
  TextField,
  Checkbox,
  Button,
  Container,
  Box,
  Typography,
  Chip,
  alpha,
  Paper,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { userLimits } from '../../dashboard/uitls/userLimits';
import moment from 'moment';
import { localDateRange } from '../../../services/method/methods';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Autocomplete } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ComputerIcon from '@mui/icons-material/Computer';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

Date.prototype.toShortFormat = function () {
  let monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  let day = this.getDate();

  let monthIndex = this.getMonth();
  let monthName = monthNames[monthIndex];

  let year = this.getFullYear();

  return `${day}-${monthName}-${year}`;
};

export default function DownloadSales(props) {
  const theme = useTheme();
  const { userEmail, filterd, setFiltered } = useContext(UserContext);
  //start at first date of this month
  var date = new Date();
  const [startDate, setStartDate] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date());
  const [order, setOrder] = useState([]);
  const [machines, setMachines] = useState([]);
  const [machineName, setMachineName] = useState('All Machines');
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [groupV, setgroupV] = useState([]);
  const [radio, setRadio] = useState('a');
  const user = JSON.parse(localStorage.getItem('user'));

  // console.log(user);
  const { id, tableTitle, superAdmin } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Transactions',
    'view_trans'
  );

  const getAllEmployeesURL = `/users/getAllEmployees`;
  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getAllEmployees() {
      await request({
        method: 'get',
        url: getAllEmployeesURL,
      })
        .then((res) => {
          if (!isCancelled) {
            setGroups(res.data);
            setLoading(true);
            console.log('all admin', res.data);
          }
        })
        .catch((err) => {
          setLoading(true);
        });
    }

    getAllEmployees();

    return () => {
      isCancelled = true;
    };
  }, []);
  const handleStartDate = (e) => {
    setStartDate(e);
  };

  const handleEndDate = (e) => {
    setEndDate(e);
  };

  const handleRowUpdate = (newData, oldData) => {
    const installed_date = newData?.installed_date;
    console.log('row installed_date', newData);
    // const dataUpdate = [...data];
    // const index = oldData.tableData.id;
    request({
      method: 'post',
      url: `/machines/updateInstallDateForMachine`,
      data: {
        machineID: newData.MachineID,
        installed_date: installed_date,
      },
    })
      .then((res) => {
        setOrder((pres) =>
          pres.map((e) =>
            e.MachineID === newData.MachineID ? { ...e, installed_date: newData.installed_date } : e
          )
        );
      })
      .catch((err) => {
        setLoading(true);
      });

    // dataUpdate[index] = newData;
    // setData([...dataUpdate]);
    // Here you would typically also make an API call to update the data on the server
  };

  const handleSearch = async (event) => {
    if (radio === 'a') {
      setLoading(false);
      const { startDateString, endDateString } = localDateRange(startDate, endDate);
      await request({
        method: 'post',
        url: `/downloadSalesForShiva`,
        data: {
          startDate: startDateString,
          endDate: endDateString,
          id: id,
        },
      }).then(async (res) => {
        res.data.forEach((mc) => {
          //check mc.belongTo from groups
          const index = groups.findIndex((e) => e.email === mc.belongTo);
          if (index !== -1) {
            mc.groupCode = groups[index].groupCode.toUpperCase();
          }
        });
        console.log('received', res.data);
        setOrder(res.data);
        setLoading(true);
      });
    }
  };
  let columns = [
    {
      title: 'Machine ID',
      field: 'MachineID',
      editable: 'never',
      render: (rowData) => (
        <Chip
          icon={<ComputerIcon sx={{ fontSize: 16 }} />}
          label={rowData.MachineID}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.info.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Sales',
      field: 'Sales',
      editable: 'never',
      render: (rowData) => (
        <Chip
          icon={<AttachMoneyIcon sx={{ fontSize: 16 }} />}
          label={rowData.Sales}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.success.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Client',
      field: 'groupCode',
      editable: 'never',
      render: (rowData) => (
        <Chip
          icon={<BusinessIcon sx={{ fontSize: 16 }} />}
          label={rowData.groupCode || 'N/A'}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.primary.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Installed Date',
      field: 'installed_date',
      render: (rowData) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CalendarTodayIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
          <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
            {rowData.installed_date || 'Not set'}
          </Typography>
        </Box>
      ),
    },
  ];

  const handleExportCSV = () => {
    if (order.length === 0) {
      return;
    }

    // Define CSV headers
    const headers = columns.map((col) => col.title).join(',');

    // Map data to CSV rows
    const rows = order.map((row) => {
      return columns
        .map((col) => {
          let value = row[col.field] || '';
          // Escape commas and quotes
          if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
            value = `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        })
        .join(',');
    });

    // Combine headers and rows
    const csv = [headers, ...rows].join('\n');

    // Create blob and download
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute(
      'download',
      `Sales_${startDate.toShortFormat()}_to_${endDate.toShortFormat()}.csv`
    );
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <ModernPageContainer>
      {!loading && <LoadingIcon />}

      <ModernPageHeader
        title="Download Sales"
        subtitle="View and manage sales data with installed dates"
        icon={DownloadIcon}
        buttons={[
          {
            text: 'Export CSV',
            onClick: handleExportCSV,
            icon: DownloadIcon,
            variant: 'contained',
            color: 'primary',
            disabled: order.length === 0,
          },
        ]}
      />

      <Paper
        sx={{
          p: 3,
          mt: 3,
          borderRadius: 3,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Container maxWidth="xl" sx={{ px: 0 }}>
          <Grid container spacing={3}>
            <Grid xs={4} item container justifyContent="flex-start" alignContent="center">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  value={startDate}
                  onChange={(e) => handleStartDate(e)}
                  label="Select start date"
                  format="MM/dd/yyyy"
                  slotProps={{
                    textField: {
                      margin: 'normal',
                      id: 'date-picker-start',
                      sx: { mr: 1 },
                    },
                  }}
                />
                <DatePicker
                  value={endDate}
                  onChange={(e) => handleEndDate(e)}
                  label="Select end date"
                  format="MM/dd/yyyy"
                  slotProps={{
                    textField: {
                      margin: 'normal',
                      id: 'date-picker-end',
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid xs={8} item container alignItems="center">
              <Grid
                lg={3}
                item
                container
                justifyContent="flex-start"
                style={{ marginRight: '20px' }}
              >
                <RadioGroup
                  name="bg_radio"
                  style={{ height: '100%' }}
                  onChange={(e) => {
                    setRadio(e.target.value);
                    setgroupV([]);
                  }}
                >
                  <FormControlLabel
                    style={{ margin: 0 }}
                    value="a"
                    control={<Radio />}
                    label="TCN"
                    checked={radio == 'a'}
                  />
                  {/* <FormControlLabel
                    style={{ margin: 0 }}
                    value="g"
                    control={<Radio />}
                    label="Client"
                    checked={radio == 'g'}
                  /> */}
                </RadioGroup>
              </Grid>
              <Grid container item xs={6} alignItems="center" justifyContent="flex-start">
                <Grid container item xs={12} alignItems="center" justifyContent="center">
                  {radio == 'a' && (
                    <TextField variant="outlined" label="All Machines" fullWidth disabled />
                  )}

                  {radio == 'g' && (
                    <Autocomplete
                      value={groupV}
                      options={groups}
                      disableCloseOnSelect
                      onChange={(event, value) => {
                        setgroupV(value);
                      }}
                      isOptionEqualToValue={(option, value) => option._id === value._id}
                      getOptionLabel={(option) => option.groupname}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.groupname}
                        </li>
                      )}
                      fullWidth
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" label="Groups" />
                      )}
                    />
                  )}
                </Grid>
              </Grid>

              <Grid item xs={1} style={{ marginLeft: '15px' }}>
                <Button
                  style={{ height: '40px' }}
                  onClick={handleSearch}
                  variant="contained"
                  color="primary"
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Paper>

      <Box sx={{ mt: 3 }}>
        <ModernTable
          // onRowsPerPageChange={setPagination}
          title={'Download Sales'}
          columns={columns}
          data={order}
          options={{
            exportButton: true,
            exportAllData: true,
            exportFileName: `Sales_${startDate.toShortFormat()}_to_${endDate.toShortFormat()}`,
            actionsColumnIndex: -1,
            pageSize: 100,
            pageSizeOptions: [10, 20, 50, 100, 200],
            rowStyle: (rowData) => {},
          }}
          actions={[]}
          editable={{
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve, reject) => {
                setTimeout(() => {
                  handleRowUpdate(newData, oldData);
                  resolve();
                }, 1000);
              }),
          }}
        />
        <Box sx={{ mt: 2 }}>
          <BackButton />
        </Box>
      </Box>
    </ModernPageContainer>
  );
}
